import { createContext } from 'react';
import { useFiltersContext } from '../../../../../Dashboards/Common/Filters/hooks/useFiltersContext';
import { QUERY_KEYS_SIA, useChartsData } from '../../../../Common/hooks/useChartsData';
import { subtitlesMap } from '../../../Common/maps/subtitleMap';

export const ServicesChartsDataContext = createContext();

const ServicesChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SIA.INCREASE_IN_VALUES,
            url: 'governanceroom/dashboard/services/production/increment'
        },
        {
            location: filters.unidade.value,
            year: filters.ano?.value,
            month: filters.competencia?.value,
        }
    );

    const chartData = data ? {
        indexes: data.indexes || [{
            valor_complemento_federal: 0,
            valor_complemento_local: 0,
            valor_incremento: 0,
        }],
        selectedYear: data.selectedYear || [],
        increments: data.increments || [],
    } : {
        indexes: [{
            valor_complemento_federal: 0,
            valor_complemento_local: 0,
            valor_incremento: 0,
        }],
        selectedYear: [],
        increments: [],
    };
    
    

    const subtitlesSelectedYear = subtitlesMap[QUERY_KEYS_SIA.INCREASE_IN_VALUES].map(
        (item) => item.description
    );

    const colors = subtitlesMap[QUERY_KEYS_SIA.INCREASE_IN_VALUES].map((item) => item.color);

    return (
        <ServicesChartsDataContext.Provider
            value={{
                chartData,
                subtitlesSelectedYear,
                colors,
                isLoading,
                isError,
                filters,
                module,
                data
            }}
        >
            {children}
        </ServicesChartsDataContext.Provider>
    );
};

export default ServicesChartsDataProvider;
